'use strict';

import { groupBy } from './Functional';

export function convertFilesToFolderStructure(files, imageExtList, fileExtList) {
  const escapeRegExp = (text) => text.replace(/[-[\]{}()*+?.,\\^$#\s]/g, '\\$&')
  const folderName = file => file.webkitRelativePath.split('/')[1]
  const extensionMatcherRegExp = (extList) => new RegExp(`(${escapeRegExp(extList.join('|'))})$`)
  const isImage = file => file.size > 0 && file.name.toLowerCase().match(extensionMatcherRegExp(imageExtList))
  const isModel = file => file.size > 0 && file.name.toLowerCase().match(extensionMatcherRegExp(fileExtList))
  const fileType = file => isImage(file) ? 'images' : (isModel(file) ? 'files' : 'other')

  const structure = Array.from(groupBy(files, folderName)).map((folder, index) => {
    const groupedFiles = groupBy(folder[1], fileType)
    const images = groupedFiles.get('images') || []
    const files = groupedFiles.get('files') || []
    const other = groupedFiles.get('other') || []

    return {
      folderName: folder[0],
      images: images,
      files: files,
      other: other,
      isValid: images.length > 0 && files.length > 0,
      id: index
    }
  })

  return structure
}
